import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';

@Component({
  selector: 'ngx-clients-modal',
  templateUrl: './clients-modal.component.html',
  styleUrls: ['./clients-modal.component.scss']
})
export class ClientsModalComponent implements OnInit {
  _clients: string[] = [
    'Client #1',
    'Client #2',
    'Loto-Québec',
    'Simons',
    'Nationex',
    'Bentley'
  ];

  @ViewChild('clients', {static: false}) clients;

  constructor(public dialogRef: MatDialogRef<ClientsModalComponent>) {}

  ngOnInit(): void {}

  selectedClients = this._clients;

  onKey(value) {
    this.selectedClients = this.search(value);
  }

  onConfirm() {
    console.log(this.clients.selectedOptions.selected);
  }

  onDismiss() {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }

  search(value: string) {
    const filter = value.toLowerCase();
    return this._clients.filter((option) =>
      option.toLowerCase().startsWith(filter)
    );
  }
}
